export default __webpack_public_path__ + "static/media/cs-campaigns-old.fb8f3300.png";